import { webApi } from "../../../../core/http/httpThunks";
import { SecurityStatisticsApiResponse } from "../types";

export const getSecurityStatisticsApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<SecurityStatisticsApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityStatisticsApi;
